<template>
  <div class="bg-white rounded-lg p-3 mx-4 w-[calc(100%-2rem)]">


    <!-- 运费金额 -->
    <div class="flex justify-between  py-2 border-b border-gray-100" v-if="showShippingFee">
      <div class="flex-1">
        <div class="text-sm text-gray-800">{{ $t("products.shippingFee") }}</div>
        <div class="text-xs text-gray-400 ">{{ $t("products.freeShippingNote") }}</div>
      </div>
      <div class="text-sm text-gray-800 font-medium ">RM {{ formatToYuan(priceInfo && priceInfo.deliveryPrice) }}</div>
    </div>

    <!-- 商品小计 -->
    <div class="flex justify-between items-center py-2 border-b border-gray-100">
      <span class="text-sm text-gray-800">{{ $t("products.subtotal") }}</span>
      <span class="text-sm text-gray-800 font-medium">RM {{ formatToYuan(priceInfo && priceInfo.totalPrice) }}</span>
    </div>

    <!-- YoYo币使用 -->
    <div class="py-2 border-b border-gray-100" v-if="isLoggedIn">
      <div class="flex items-center gap-2 flex-wrap">
        <!-- <van-icon name="gold-coin-o" color="#ff7a00" size="18" /> -->
        <img :src="YoyoCoinsSrc" alt="Yoyo Coins" class="w-4 h-4 inline-block" />
        <span class="text-xs text-gray-600 flex-1 flex items-center flex-wrap">
          <span>
            {{ $t("products.currentYoyoCoins") }}{{ (priceInfo && priceInfo.totalPoint) || 0 }}{{ $t("products.availableYoyoCoins") }}
          </span>
          <van-field :value="usePoint" @input="onUsePointInput" class="w-16 border border-gray-100 pr-0 inline-block p-0 ml-2" />

          <span v-if="priceInfo">
            {{ $t("products.yoyoDiscount")
            }}{{ priceInfo.pointPrice ? formatToYuan(priceInfo.pointPrice) : formatToYuan(priceInfo.userPoint) }}）
          </span>
        </span>

        <van-icon :name="yoyoUsed ? 'checked' : 'circle'" color="#ff7a00" size="20" @click="useYoyo" />
      </div>
    </div>

    <!-- 优惠券 -->
    <div class="flex items-center gap-3 py-0 border-b border-gray-100">
      <span class="text-sm text-gray-800 min-w-15">{{ $t("products.coupon") }}</span>
      <van-field
        v-model="selectedCoupon"
        input-align="right"
        readonly
        is-link
        arrow-direction="down"
        @click="handleCouponClick"
        class="flex-1 pr-0" />
    </div>

    <!-- 付款总额 -->
    <div class="pt-2">
      <div class="flex justify-between items-center">
        <span class="text-base font-bold text-gray-800">{{ $t("products.totalAmount") }}</span>
        <span class="text-lg font-bold">RM {{ formatToYuan(priceInfo && priceInfo.payPrice) }}</span>
      </div>
    </div>

    <!-- 优惠券选择弹窗 -->
    <div class="coupon-picker">
      <van-popup v-model="showCouponPicker" position="bottom" style="height: 60%; padding-top: 4px;">
        <van-coupon-list
          disabled-title=""
          :coupons="couponOptions"
          :chosen-coupon="chosenCoupon"
          :show-exchange-bar="false"
          :show-count="false"
          :close-button-text="$t('coupons.noCoupons')"
          @change="onCouponConfirm" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Picker, CouponCell, CouponList, Toast } from "vant"
import { getCouponList } from "@/apis/mine"
import { mapGetters } from "vuex"
import { formatToYuan } from "@/utils/common"
export default {
  name: "PaymentSummary",
  components: {
    [Picker.name]: Picker,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
  },
  props: {
    subtotal: {
      type: Number,
      default: 376,
    },
    priceInfo: {
      type: Object,
      default: () => {},
    },
    settlementDataErrCode: {
      type: String | Number,
      default: "",
    },
    showShippingFee: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      yoyoBalance: 0,
      availableYoyo: 0,
      yoyoValue: 0,
      yoyoUsed: false,
      selectedCoupon: "",
      showCouponPicker: false,
      couponOptions: [],
      chosenCoupon: -1,
      formatToYuan,
      usePoint: 0,
      YoyoCoinsSrc: require("@/assets/images/yoyo.png"),
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  watch: {
    settlementDataErrCode(newVal) {
        console.log("newVal :>> ", newVal)
      if (newVal == 'ECONNABORTED') {
        console.log("超时 :>> ", newVal)
        this.yoyoUsed = false
        this.$emit("yoyo-used", this.yoyoUsed, false, this.usePoint)

        this.selectedCoupon = ""
        this.chosenCoupon = -1
        setTimeout(() => {
          this.$emit("coupon-selected", "", false)
        }, 10)

      }
      if (newVal == "1011000041") {
        this.useYoyo(false)
      }
      // 优惠券使用失败
      if (newVal == "1011003006") {
        console.log('obj优惠券使用失败ect :>> ', newVal);
        this.selectedCoupon = ""
        this.chosenCoupon = -1
        setTimeout(() => {
          this.$emit("coupon-selected", "", false)
        }, 10)
      }

      // 优惠券和yoyo币不能同时使用
      if (newVal == "1011000039") {
        console.log('优惠券和yoyo币不能同时使用 :>> ', newVal);
        this.useYoyo(false)
        this.selectedCoupon = ""
        this.chosenCoupon = -1
        setTimeout(() => {
          this.$emit("coupon-selected", "", false)
        }, 10)
        this.$emit("reset", )
      }
    },
    priceInfo: {
      handler(newVal) {
        if (newVal && !this.usePoint) {
          console.log("priceInfo :>> ", newVal)
          this.usePoint = newVal.userPoint || 0
        }
      },
      deep: true,
      immediate: true,
    },
    usePoint(newVal, oldVal) {
      if (oldVal != newVal && this.yoyoUsed) {
        // console.log("usePoint :>> ", oldVal, newVal)
        // console.log("this.yoyoUsed :>> ", this.yoyoUsed)
        this.$emit("yoyo-used", this.yoyoUsed, true, newVal)
      }
    },
  },
  methods: {
    onUsePointInput(value) {
      if (!this.priceInfo) return
      if (value > this.priceInfo.totalPoint) {
        Toast(this.$t("products.yoyoPointNotEnough"))
        this.usePoint = this.priceInfo.userPoint
        return
      }
      this.usePoint = value
    },
    useYoyo(isRefresh) {
      this.yoyoUsed = !this.yoyoUsed
      this.$emit("yoyo-used", this.yoyoUsed, isRefresh, this.usePoint)
    },
    onCouponConfirm(value) {
      console.log("value :>> ", value)
      this.chosenCoupon = value
      this.showCouponPicker = false
      if (value == -1) {
        this.selectedCoupon = ""
        this.$emit("coupon-selected", "", true)
      } else {
        this.selectedCoupon = this.couponOptions[value].name
        this.$emit("coupon-selected", this.couponOptions[value].id, true)
      }
    },
    async getCouponList() {
      if (!this.isLoggedIn) {
        return
      }
      try {
        const couponList = await getCouponList()
        this.showCouponPicker = true
        const list = couponList.data.list || []
        //筛选出状态为1的 并且使用门槛小于等于 subtotal
        const newCouponList = list.filter((item) => item.status == 1)

        this.couponOptions = newCouponList.map((item) => {
          return {
            name: this.isZh ? item.name : item.nameEn,
            condition: this.isZh
              ? `满RM ${formatToYuan(item.usePrice, 0)}可用`
              : `Valid with a minimum \n spend of RM ${formatToYuan(item.usePrice, 0)}`,
            startAt: item.validStartTime,
            endAt: item.validEndTime,
            valueDesc: "RM",
            unitDesc: formatToYuan(item.discountPrice, 0),
            id: item.id,
          }
        })
      } catch (error) {}
    },
    handleCouponClick() {
      if (!this.isLoggedIn) {
        return
      }
      this.getCouponList()
    },
  },
  created() {
    // this.getCouponList()
  },
}
</script>

<style scoped>
/deep/.van-tab {
  display: none;
}
/deep/.van-tab--active {
  display: flex !important;
}
/deep/.van-tabs__line {
  display: none;
}
/deep/.van-button {
  background-color: #ff7a00;
}
/deep/.van-coupon-list__empty {
  display: flex !important;
  flex-direction: column;
  align-items: center;
}
/deep/.van-coupon__amount {
  font-size: 14px;
}

/deep/.van-coupon__amount span {
  font-size: 30px;
}

</style>
